import React, { useMemo } from 'react';
import moment from 'moment';
import { ReactTable } from '../../../../shared/ReactTable';
import { TABLE_TYPES } from '../../utils';
import '../../RfController.css';

const RfControllerGainTable = ({ showDirectionTable, data, columns }) => {
  const localTimeZone = moment.tz.guess();

  const formattedGainData = useMemo(() => {
    const formattedData = [];
    data &&
      data.forEach((targetRowData) => {
        let localTimeFormatted = 'N/A';

        if (targetRowData.lastUpdated != null) {
          let utcTime = targetRowData.lastUpdated;
          let localTime = moment.utc(utcTime).tz(localTimeZone);
          localTimeFormatted = localTime.format('MMM Do YYYY, hh:mm:ss a');
        }

        formattedData.push({
          parameter: targetRowData.parameter,
          minMax:
            (targetRowData.min ? (targetRowData.min > 0 ? '+' + targetRowData.min : targetRowData.min) : '') +
            '/' +
            (targetRowData.max ? (targetRowData.max > 0 ? '+' + targetRowData.max : targetRowData.max) : ''),
          currentValue: targetRowData.currentValue,
          lastUpdated: localTimeFormatted
        });
      });
    return formattedData;
  }, [data, localTimeZone]);

  return (
    <ReactTable
      className={showDirectionTable ? 'GainTable Global_Table' : 'NoHbfGainTable DirectionTable Global_Table'}
      noDataText={'Fetching Data...'}
      showPagination={false}
      resizable={false}
      pageSize={4}
      getTdProps={(state, rowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            if (handleOriginal) {
              handleOriginal(); /* Suggested by documentation, makes sure that default click functions still get called if necessary*/
            }
          }
        };
      }}
      data={formattedGainData}
      columns={columns}
      getProps={() => {
        return { id: TABLE_TYPES.GAIN };
      }}
    ></ReactTable>
  );
};

export default RfControllerGainTable;
